<div class="row justify-content-center">
	<div class="col-8 bgColor main-ppt-div">
		<div class="innerDivBg my-4 canvas-slides">
			<!-- <div class="row justify-content-center">
				<div class="col-md-11  canvas-slides">
				</div>
			</div> -->
		</div>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/customer/view-presentation/view-presentation.component.html